import useTrackEvent from 'personalization-lib/hooks/tracking/useTrackEvent';
import { LIBRARY_EVENT_NAMESPACE } from 'personalization-lib/constants/tracking/libEvents';
const useLibTracker = eventName => useTrackEvent(LIBRARY_EVENT_NAMESPACE, eventName);
export default useLibTracker;